import { useQueryContext } from '../contexts/QueryContext';
import { List } from '../types';

type ContactCountCellProps = {
  list: List;
};

export const ContactCountCell = ({ list }: ContactCountCellProps) => {
  const { listSizes } = useQueryContext();
  return <div data-test="contact-count-cell">{listSizes[list.id]}</div>;
};
